import {
  List, ListItem, ListItemButton, ListItemIcon, ListItemText, Box, Typography, Divider,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import swal from "sweetalert";
import useOnlineStatus from "../../Hooks/UseOnlineStatus";
import { Link } from "react-router-dom";

const ORANGE = "#ED9519";
const ORANGE_CONTRAST = "#1a0e00";

function getInitials(name = "") {
  return name.trim().split(/\s+/).map(w => w[0]).slice(0, 2).join("").toUpperCase() || "?";
}

function getRolLabel(rol) {
  if (rol === "ROLE_ADMIN") return "Administrador";
  return "Técnico";
}

export default function NavListDrawer({ navegationLinks, setOpen }) {
  const navigate   = useNavigate();
  const location   = useLocation();
  const isOnline   = useOnlineStatus();

  const nombre = localStorage.getItem("nombre-Completo") || "Usuario";
  const rol    = localStorage.getItem("roles") || "";

  const logout = () => {
    swal({
      title: "¿Deseas cerrar sesión?",
      text: "Solo podrás volver a ingresar si tenés conexión a internet.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((ok) => {
      if (ok) {
        localStorage.removeItem("usuario");
        localStorage.removeItem("roles");
        localStorage.removeItem("user-token");
        localStorage.removeItem("firma");
        localStorage.removeItem("nombre-Completo");
        navigate("/auth/login");
      }
    });
  };

  const isActive = (path) => {
    if (path === "/" || path === "") return location.pathname === "/";
    return location.pathname.toLowerCase().includes(path.toLowerCase());
  };

  return (
    <Box sx={{ width: 260, display: "flex", flexDirection: "column", height: "100%" }}>

      {/* ── Header naranja con info del usuario ── */}
      <Box sx={{ bgcolor: ORANGE, px: 2, pt: 2.5, pb: 2 }}>
        {/* Avatar */}
        <Box sx={{
          width: 46, height: 46, borderRadius: "50%",
          bgcolor: "rgba(0,0,0,0.22)",
          display: "flex", alignItems: "center", justifyContent: "center",
          mb: 1.2,
        }}>
          <Typography sx={{ fontSize: 16, fontWeight: 700, color: ORANGE_CONTRAST }}>
            {getInitials(nombre)}
          </Typography>
        </Box>

        {/* Nombre */}
        <Typography sx={{ fontSize: 14, fontWeight: 700, color: ORANGE_CONTRAST, lineHeight: 1.2 }}>
          {nombre}
        </Typography>

        {/* Rol + estado */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.6, mt: 0.4 }}>
          <FiberManualRecordIcon sx={{
            fontSize: 8,
            color: isOnline ? "rgba(0,80,0,0.7)" : "rgba(80,0,0,0.5)",
          }} />
          <Typography sx={{ fontSize: 11, color: ORANGE_CONTRAST, opacity: 0.65 }}>
            {getRolLabel(rol)} · {isOnline ? "En línea" : "Sin conexión"}
          </Typography>
        </Box>
      </Box>

      {/* ── Navegación ── */}
      <Box sx={{ flex: 1, overflowY: "auto", py: 1 }}>
        <List disablePadding>
          {navegationLinks.map((item) => {
            const active = isActive(item.path);
            return (
              <ListItem disablePadding key={item.title} sx={{ px: 1, mb: 0.25 }}>
                <ListItemButton
                  component={Link}
                  to={item.path}
                  onClick={() => setOpen(false)}
                  sx={{
                    borderRadius: 2,
                    py: 0.9,
                    bgcolor: active ? "rgba(237,149,25,0.14)" : "transparent",
                    "&:hover": {
                      bgcolor: active ? "rgba(237,149,25,0.2)" : "rgba(237,149,25,0.06)",
                    },
                  }}
                >
                  <ListItemIcon sx={{
                    minWidth: 36,
                    color: active ? ORANGE : "text.secondary",
                  }}>
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText
                    primary={item.title}
                    primaryTypographyProps={{
                      fontSize: 13,
                      fontWeight: active ? 600 : 400,
                      color: active ? "text.primary" : "text.secondary",
                    }}
                  />
                  {active && (
                    <Box sx={{
                      width: 5, height: 5, borderRadius: "50%",
                      bgcolor: ORANGE, flexShrink: 0, ml: 1,
                    }} />
                  )}
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Box>

      {/* ── Footer con logout ── */}
      <Box>
        <Divider />
        <List disablePadding sx={{ py: 0.5 }}>
          <ListItem disablePadding sx={{ px: 1 }}>
            <ListItemButton
              onClick={logout}
              sx={{
                borderRadius: 2,
                py: 0.9,
                "&:hover": { bgcolor: "rgba(239,68,68,0.08)" },
              }}
            >
              <ListItemIcon sx={{ minWidth: 36, color: "error.main" }}>
                <LogoutIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="Cerrar sesión"
                primaryTypographyProps={{ fontSize: 13, color: "error.main" }}
              />
            </ListItemButton>
          </ListItem>
        </List>
      </Box>

    </Box>
  );
}
